package com.isaias.fyattravel.web.navigation

import kotlinx.browser.window

/**
 * Route constants for web navigation
 */
object Routes {
    const val HOME = "/"
    const val CATEGORIES = "/categories"
    const val FLIGHTS = "/flights"
    const val STAYS = "/stays"
    const val CARS = "/cars"
    const val VISA = "/visa_logo"
    const val EXPLORE = "/explore"
    const val CART = "/cart"
    const val PROFILE = "/profile"
    const val AUTH = "/auth"
    const val CONTACT = "/contact"
    const val ADMIN = "/admin"
    const val CHECKOUT = "/checkout"
    const val SEARCH = "/search"
    
    // Dynamic routes
    fun category(name: String) = "/category/$name"
    fun product(id: String) = "/product/$id"
}

/**
 * Parse route path from URL hash
 */
fun currentRoute(): String {
    val raw = window.location.hash.orEmpty()
    val trimmed = raw.removePrefix("#")
    return if (trimmed.isBlank()) "/" else trimmed
}

/**
 * Parse path without query params
 */
fun parsePath(route: String): String = route.substringBefore("?").trim().ifEmpty { "/" }

/**
 * Parse query parameter from route
 */
fun parseQueryParam(route: String, key: String): String? {
    val query = route.substringAfter("?", missingDelimiterValue = "")
    if (query.isBlank()) return null
    val pairs = query.split("&").mapNotNull { part ->
        val idx = part.indexOf("=")
        if (idx <= 0) return@mapNotNull null
        val k = part.substring(0, idx)
        val v = part.substring(idx + 1)
        k to v
    }
    val raw = pairs.firstOrNull { it.first == key }?.second ?: return null
    return try {
        js("decodeURIComponent")(raw) as String
    } catch (_: dynamic) {
        raw
    }
}

/**
 * Encode string for URL query parameter
 */
fun encodeQuery(value: String): String = try {
    js("encodeURIComponent")(value) as String
} catch (_: dynamic) {
    value
}
